import DataTable from '../../../../../components/Datatable';
import Loading from '../../../../../components/Loading';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { query, query_share } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';

class Brands extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);

        this.state = {
            data: [],
            loading: true,
            totalMentions: 1,
        };
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                platforms: this.props.platforms,
            });
            this.query_share = query_share({
                prompt_uids: this.props.prompt_uids,
            });
            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            this.query_share.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const results_share = await this.query_share.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));
            const data_share = results_share?.map((x) => ({ id: uuid(), ...x }));
            const totalMentions = data_share?.[0]?.total_mentions;
            this.setState({
                data,
                loading: false,
                totalMentions,
            });

            if (this.props.setOwnValue) {
                const ownDomain = data.find(
                    (item) =>
                        item.brand?.toLowerCase() ===
                        this.props.project?.own_product_name?.toLowerCase(),
                );

                const mentionsShare =
                    ownDomain?.mentions && totalMentions
                        ? ((ownDomain.mentions / totalMentions) * 100).toFixed(2)
                        : 0;

                this.props.setOwnValue('ownSentiment', ownDomain?.avgSentiment || 0);
                this.props.setOwnValue('ownBrandMentions', mentionsShare || 0);
            }
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.brand?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;
        const columns = COLUMNS(
            this.props.totalRuns,
            t,
            this.props.project,
            this.props.updateProject,
            this.state.totalMentions,
        );

        return (
            <div className="card table-main rounded-main ">
                {this.state.loading && <Loading padding={10} />}
                {!this.state.loading && (
                    <DataTable
                        nodes={this.state.data ?? []}
                        sortFns={getSortKeys(columns)}
                        searchFunction={this.searchFunction}
                        COLUMNS={columns}
                        defaultSortKey={'mentions_share'}
                        header={t('ai_tracking.keyword_detail.brands.header')}
                        customEmptyMessage={t('global.no_data')}
                        forceRun={this.forceRun}
                        additionalStyles={setAdditionalStyles(columns)}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(Brands);
